import {createAuth0} from '@auth0/auth0-vue'

export function initAuth(app, {domain, clientId, audience}) {
  app.use(
    createAuth0({
      domain,
      clientId,
      authorizationParams: {
        audience,
        redirect_uri: window.location.origin
      },
      cacheLocation: 'memory'
    })
  )
}
